"use client";

import { type ReactNode } from "react";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

type TermsAndPrivacyNoticeProps = {
  prefix: ReactNode;
  className?: string;
  linkClassName?: string;
};

const TermsAndPrivacyNotice = ({
  prefix,
  className,
  linkClassName,
}: TermsAndPrivacyNoticeProps) => {
  return (
    <p className={cn("text-[13px] leading-relaxed text-caption", className)}>
      {prefix}{" "}
      <Link
        href="/term-and-condition"
        className={cn("text-secondary hover:underline", linkClassName)}
      >
        terms &amp; conditions
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy-policy"
        className={cn("text-secondary hover:underline", linkClassName)}
      >
        privacy policy
      </Link>
      .
    </p>
  );
};

export default TermsAndPrivacyNotice;
